import {
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  limit,
} from "firebase/firestore";
import { db } from "../firebase";
import axios from "axios";
import availableChecker from "./availableChecker";
import { serverDomain } from "./mailSender";
import { checkIsWorking } from "./getInfoList";

const getInfo = async (
  domain,
  fromUrl,
  setFirstAccount,
  setOnline,
  setHaveSubbutton,
  setBookingSlug
) => {
  let firstAccountId = "";
  try {
    let domainCheck;
    const httpIndex = fromUrl.indexOf("://");
    const domainIndex = fromUrl.indexOf("/", httpIndex + 3);
    if (domainIndex !== -1) {
      domainCheck = fromUrl.slice(httpIndex + 3, domainIndex);
    } else if (domainIndex === -1) {
      domainCheck = fromUrl.slice(httpIndex + 3);
    }
    // console.log("domainCheck:", domainCheck);

    const docRef = await getDocs(
      query(
        collection(db, "site"),
        where("domain", "==", domain),
        where("userSite", "==", domainCheck),
        orderBy("created_at", "desc"),
        limit(1)
      )
    );

    let userIdList = [];
    let tempFirstId = "";
    docRef.forEach((element) => {
      userIdList = userIdList.concat(element.data().account ?? []);
      tempFirstId = element.data().isFirst;
    });

    // 全てのアカウントの中に１つがオンラインとしたら、オンラインと判定。
    // 同時に日程調整の予約リンクも拾う（担当者ごとに設定されるため）。
    const { isOnline, bookingSlug } = await scanAccounts(userIdList);
    setOnline(isOnline);
    if (setBookingSlug) setBookingSlug(bookingSlug);

    // 表示するアカウントを選択
    firstAccountId = userIdList.find((item) => item === tempFirstId);
  } catch (error) {
    console.log(error);
  }

  let temp = {};
  try {
    const docRef2 = await getDoc(doc(db, "account", firstAccountId));
    temp = docRef2.data();
    temp.id = docRef2.id;
    // ボタンの取得
    let buttonTemp = [];
    if (docRef2.data().isOneSubButton === true) {
      const docRef3 = await getDocs(
        query(
          collection(db, "account", firstAccountId, "button"),
          where("isOnly", "==", true)
        )
      );
      docRef3.forEach((ele) => {
        buttonTemp.push(ele.data());
        if (ele.data().title === "") {
          setHaveSubbutton(false);
        } else {
          setHaveSubbutton(true);
        }
      });
    } else {
      const docRef4 = await getDocs(
        query(
          collection(db, "account", firstAccountId, "button"),
          where("isOnly", "==", false)
        )
      );
      docRef4.forEach((ele) => {
        buttonTemp.push(ele.data());
      });
    }
    temp.button = buttonTemp;
  } catch (error) {
    console.log(error);
  }
  setFirstAccount(temp);
};

/**
 * サイトに紐づく全アカウントを調べて「いま対応できる人がいるか」と
 * 「日程調整の予約リンク」を返す。
 *
 * 予約リンクの選び方は lead-dynamics の widget.js renderPresence() と同じで、
 * 予約リンクを持つ担当者のうちオンラインの人を優先し、居なければ先頭を使う。
 * 「はじめに表示する担当者」が日程調整を設定しているとは限らないため、
 * firstAccount だけを見るのでは取りこぼす。
 */
async function scanAccounts(userIdList) {
  // 直列に待つと担当者の数だけ待たされるので、オンライン判定はまとめて投げる
  const accounts = await Promise.all(
    userIdList.map(async (id) => {
      const snapshot = await getDoc(doc(db, "account", id));
      const temp = { ...snapshot.data(), id: snapshot.id };
      if (temp.isGoogleCalendar) {
        try {
          const result = await axios.get(
            `${serverDomain}/google?google=${temp.googleId}`
          );
          temp.online = result.data.isOnline ? availableChecker(temp) : false;
        } catch (error) {
          // 予定を取れないときは「今すぐ商談」に流さない
          temp.online = false;
        }
        temp.isWorking = false;
      } else {
        temp.online = availableChecker(temp);
        temp.isWorking = checkIsWorking(temp.lastStartedAt);
      }
      return temp;
    })
  );

  let isOnline = false;
  let bookingSlug = "";
  accounts.forEach((temp) => {
    const available = temp.online && !temp.isWorking;
    if (available) isOnline = true;
    const slug =
      temp.bookingEnabled && temp.bookingSlug ? temp.bookingSlug : "";
    if (slug && (!bookingSlug || available)) bookingSlug = slug;
  });

  return { isOnline, bookingSlug };
}

export default getInfo;
